import type { MonitorBodySchema } from "./server";

const _captureEvent = async (params: MonitorBodySchema) => {
  const body: MonitorBodySchema = {
    ...params,
  };
  await fetch("/api/monitoring", {
    method: "POST",
    body: JSON.stringify(body),
  });
};

export const captureEvent = (
  params: Omit<MonitorBodySchema, "originatedFromClient">,
) => {
  void _captureEvent({
    ...params,
    originatedFromClient: true,
  });
};
